var json = {
  Type: [
    {
      name: "Name",
      Fonts: [
        {
          name: "Simple Script",
          image:
            "https://cdn.shopify.com/s/files/1/0764/0265/5519/files/SS.png",
          unique: "SS",
          max_length: "8",
        },
        {
          name: "Script Circle",
          image:
            "https://cdn.shopify.com/s/files/1/0764/0265/5519/files/SFC.png",
          unique: "SFC",
          max_length: "8",
        },
        {
          name: "Script Straight",
          image:
            "https://cdn.shopify.com/s/files/1/0764/0265/5519/files/SFS.png",
          unique: "SFS",
          max_length: "8",
        },
        {
          name: "Font Circle",
          image:
            "https://cdn.shopify.com/s/files/1/0764/0265/5519/files/FC.png",
          unique: "FC",
          max_length: "8",
        },
        {
          name: "Simple Block",
          image:
            "https://cdn.shopify.com/s/files/1/0764/0265/5519/files/SBF.png",
          unique: "SBF",
          max_length: "8",
        },
        {
          name: "Serif Block",
          image:
            "https://cdn.shopify.com/s/files/1/0764/0265/5519/files/SBF2.png",
          unique: "SBF2",
          max_length: "8",
        },
      ],
      Color: [
        {
          name: "WaterMelon",
          swatch: "https://www.jacarandaliving.com/media/monogram/color1.jpg",
          code: "#D84C89",
          unique: "MC1",
        },
        {
          name: "Red",
          swatch: "https://www.jacarandaliving.com/media/monogram/color2.jpg",
          code: "#DB152C",
          unique: "MC2",
        },
        {
          name: "Hot Pink",
          swatch: "https://www.jacarandaliving.com/media/monogram/color3.jpg",
          code: "#F52563",
          unique: "MC3",
        },
        {
          name: "Blush",
          swatch: "https://www.jacarandaliving.com/media/monogram/color4.jpg",
          code: "#dfbfca",
          unique: "MC4",
        },
        {
          name: "Yellow Gold",
          swatch: "https://www.jacarandaliving.com/media/monogram/color6.jpg",
          code: "#e4ce9d",
          unique: "MC5",
        },
        {
          name: "Light Camel",
          swatch: "https://www.jacarandaliving.com/media/monogram/color5.jpg",
          code: "#f6f7f2",
          unique: "MC6",
        },
        {
          name: "Forest GREEN",
          swatch: "https://www.jacarandaliving.com/media/monogram/color7.jpg",
          code: "#386348",
          unique: "MC7",
        },
        {
          name: "Mint Green",
          swatch: "https://www.jacarandaliving.com/media/monogram/color8.jpg",
          code: "#49b971",
          unique: "MC8",
        },
        {
          name: "Robin Egg",
          swatch: "https://www.jacarandaliving.com/media/monogram/color9.jpg",
          code: "#25a9be",
          unique: "MC9",
        },
        {
          name: "Silver Grey",
          swatch: "https://www.jacarandaliving.com/media/monogram/color10.jpg",
          code: "#bebec0",
          unique: "MC10",
        },
        {
          name: "Black",
          swatch: "https://www.jacarandaliving.com/media/monogram/color11.jpg",
          code: "#414048",
          unique: "MC11",
        },
        {
          name: "Blue",
          swatch: "https://www.jacarandaliving.com/media/monogram/color12.jpg",
          code: "#484a85",
          unique: "MC12",
        },
        {
          name: "Coral",
          swatch: "https://www.jacarandaliving.com/media/monogram/color13.jpg",
          code: "#ec756f",
          unique: "MC13",
        },
        {
          name: "Light Blue",
          swatch: "https://www.jacarandaliving.com/media/monogram/color14.jpg",
          code: "#95aed6",
          unique: "MC14",
        },
      ],
    },
    {
      name: "Initials",
      Fonts: [
        {
          name: "Simple Script",
          image:
            "https://cdn.shopify.com/s/files/1/0764/0265/5519/files/SS.png",
          unique: "SS",
          max_length: "3",
        },
        {
          name: "Script Circle",
          image:
            "https://cdn.shopify.com/s/files/1/0764/0265/5519/files/SFC.png",
          unique: "SFC",
          max_length: "3",
        },
        {
          name: "Script Straight",
          image:
            "https://cdn.shopify.com/s/files/1/0764/0265/5519/files/SFS.png",
          unique: "SFS",
          max_length: "3",
        },
        {
          name: "Font Circle",
          image:
            "https://cdn.shopify.com/s/files/1/0764/0265/5519/files/FC.png",
          unique: "FC",
          max_length: "3",
        },
        {
          name: "Simple Block",
          image:
            "https://cdn.shopify.com/s/files/1/0764/0265/5519/files/SBF.png",
          unique: "SBF",
          max_length: "3",
        },
        {
          name: "Serif Block",
          image:
            "https://cdn.shopify.com/s/files/1/0764/0265/5519/files/SBF2.png",
          unique: "SBF2",
          max_length: "3",
        },
        {
          name: "Floral Font",
          image:
            "https://cdn.shopify.com/s/files/1/0764/0265/5519/files/FF.png",
          unique: "FF",
          max_length: "1",
        },
      ],
      Color: [
        {
          name: "WaterMelon",
          swatch: "https://www.jacarandaliving.com/media/monogram/color1.jpg",
          code: "#D84C89",
          unique: "MC1",
        },
        {
          name: "Red",
          swatch: "https://www.jacarandaliving.com/media/monogram/color2.jpg",
          code: "#DB152C",
          unique: "MC2",
        },
        {
          name: "Hot Pink",
          swatch: "https://www.jacarandaliving.com/media/monogram/color3.jpg",
          code: "#F52563",
          unique: "MC3",
        },
        {
          name: "Blush",
          swatch: "https://www.jacarandaliving.com/media/monogram/color4.jpg",
          code: "#dfbfca",
          unique: "MC4",
        },
        {
          name: "Yellow Gold",
          swatch: "https://www.jacarandaliving.com/media/monogram/color6.jpg",
          code: "#e4ce9d",
          unique: "MC5",
        },
        {
          name: "Light Camel",
          swatch: "https://www.jacarandaliving.com/media/monogram/color5.jpg",
          code: "#f6f7f2",
          unique: "MC6",
        },
        {
          name: "Forest GREEN",
          swatch: "https://www.jacarandaliving.com/media/monogram/color7.jpg",
          code: "#386348",
          unique: "MC7",
        },
        {
          name: "Mint Green",
          swatch: "https://www.jacarandaliving.com/media/monogram/color8.jpg",
          code: "#49b971",
          unique: "MC8",
        },
        {
          name: "Robin Egg",
          swatch: "https://www.jacarandaliving.com/media/monogram/color9.jpg",
          code: "#25a9be",
          unique: "MC9",
        },
        {
          name: "Silver Grey",
          swatch: "https://www.jacarandaliving.com/media/monogram/color10.jpg",
          code: "#bebec0",
          unique: "MC10",
        },
        {
          name: "Black",
          swatch: "https://www.jacarandaliving.com/media/monogram/color11.jpg",
          code: "#414048",
          unique: "MC11",
        },
        {
          name: "Blue",
          swatch: "https://www.jacarandaliving.com/media/monogram/color12.jpg",
          code: "#484a85",
          unique: "MC12",
        },
        {
          name: "Coral",
          swatch: "https://www.jacarandaliving.com/media/monogram/color13.jpg",
          code: "#ec756f",
          unique: "MC13",
        },
        {
          name: "Light Blue",
          swatch: "https://www.jacarandaliving.com/media/monogram/color14.jpg",
          code: "#95aed6",
          unique: "MC14",
        },
      ],
    },
  ],
};
